import { Input as PlasticInput } from '@cof/plastic-components';
import PropTypes from 'prop-types';
import { styled } from 'styled-components';
import { forwardRef, useContext } from 'react';

import { numericInputPattern } from '../../../utilities/constants';
import pushToDataLayer, { EVENTS } from '../../../utilities/dataLayer';

import { FormFocusContext } from '../../FormFocusContext';
import { useLandmarkRefsContext } from '../../LandmarkRefsProvider';

export const Input = styled(PlasticInput).attrs(() => ({
    pattern: numericInputPattern,
    inputMode: 'numeric',
    type: 'text'
}))`
    min-width: 0;
    width: 100%;

    &:focus {
        background: none;
        padding-right: 0;
    }
`;
Input.displayName = 'Input';

const DatePickerInput = forwardRef(
    (
        {
            // @ts-expect-error TS2339: Property 'id' does not exist on type ''.
            id,
            // @ts-expect-error TS2339: Property 'dayMonthYear' does not exist on type ''.
            dayMonthYear,
            // @ts-expect-error TS2339: Property 'date' does not exist on type ''.
            date,
            // @ts-expect-error TS2339: Property 'validationErrorId' does not exist on type ''.
            validationErrorId,
            // @ts-expect-error TS2339: Property 'autoComplete' does not exist on type ''.
            autoComplete,
            // @ts-expect-error TS2339: Property 'setNewDate' does not exist on type ''.
            setNewDate,
            // @ts-expect-error TS2339: Property 'field' does not exist on type ''.
            field,
            // @ts-expect-error TS2339: Property 'inputVariant' does not exist on type ''.
            inputVariant,
            // @ts-expect-error TS2339: Property 'error' does not exist on type ''.
            error,
            // @ts-expect-error TS2339: Property 'thinkMoney' does not exist on type ''.
            thinkMoney,
            // @ts-expect-error TS2339: Property 'maxLength' does not exist on type ''.
            maxLength
        },
        ref
    ) => {
        const onFocus = useContext(FormFocusContext);
        // @ts-expect-error TS2339: Property 'submitAttempted' does not exist on type ''.
        const { submitAttempted } = useLandmarkRefsContext();
        return (
            <Input
                id={`${id}-${dayMonthYear}`}
                name={`${id}-${dayMonthYear}`}
                data-qa-id={`${id}-${dayMonthYear}`}
                value={date?.[dayMonthYear]}
                onChange={(event: any) => setNewDate({ ...date, [dayMonthYear]: event.target.value })}
                onFocus={() => {
                    pushToDataLayer({
                        event: EVENTS.FIELD_FOCUS,
                        fieldName: `${field.name}-${dayMonthYear}`
                    });
                    // @ts-expect-error TS2349: This expression is not callable.
                    if (onFocus) onFocus();
                }}
                ref={ref}
                autoComplete={autoComplete && autoComplete !== 'off' ? `${autoComplete}-${dayMonthYear}` : 'off'}
                variant={inputVariant}
                aria-describedby={submitAttempted && error ? validationErrorId : undefined}
                maxLength={maxLength}
                {...(thinkMoney && {
                    fontWeight: 500
                })}
            />
        );
    }
);

DatePickerInput.propTypes = {
    id: PropTypes.string,
    dayMonthYear: PropTypes.string.isRequired,
    date: PropTypes.shape({
        day: PropTypes.string,
        month: PropTypes.string,
        year: PropTypes.string
    }),
    validationErrorId: PropTypes.string,
    autoComplete: PropTypes.string,
    setNewDate: PropTypes.func,
    field: PropTypes.object,
    inputVariant: PropTypes.string,
    touched: PropTypes.bool,
    error: PropTypes.oneOfType([PropTypes.bool, PropTypes.array]),
    thinkMoney: PropTypes.bool,
    maxLength: PropTypes.number
};

export default DatePickerInput;
